import React, { Component, Suspense } from 'react';
import { Redirect, Route, Switch , Link} from 'react-router-dom';
import * as router from 'react-router-dom';
import { Container } from 'reactstrap';
import { GlobalConfig } from "../../Services/Helper/GlobalConfig";
import SweetAlert from "react-bootstrap-sweetalert";
import './Style.css';
import {
  AppAside,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppBreadcrumb2 as AppBreadcrumb,
  AppSidebarNav2 as AppSidebarNav,
} from '@coreui/react';
// sidebar nav config
import navigationAdmin from '../../_navAdmin';
import navigationClient from '../../_navClient';
// routes config
import routes from '../../routes';
import {RemoteCall} from "../../Services/http/RemoteCall";
import {ClipLoader} from "react-spinners";
const ClientAside = React.lazy(() => import('./ClientAside'));
const ClientFooter = React.lazy(() => import('./ClientFooter'));
const ClientHeader = React.lazy(() => import('./ClientHeader'));

class ClientLayout extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isAdmin: GlobalConfig.isAdmin,
      alert: null,
      baseList:[],
      loading:false
    };
  }

  // createAlert = this.createAlert.bind(this);

  componentDidMount() {

    if (!GlobalConfig.Token || !GlobalConfig.LoginId || GlobalConfig.isAdmin || GlobalConfig.isBaseUser ) {
      // alert("client")
      this.props.history.push("/login");
    }else{
      //this.getBaseList()
    }
  }
  getBaseList = () => {
    RemoteCall.AdminBaseList()
        .getAdminBaseList()
        .then(
            result => {
              console.log("[getClientList]",result);
              if (
                  result.data &&
                  result.data.statusCode === 200
              ) {
                this.setState({baseList: result.data.payload,
                  loading:false
                });
              }

            },
            err => {
              console.log(err);
              this.props.history.push('/login')
            }
        );
  }
  loading = () => <div className="animated fadeIn pt-1 text-center">Loading...</div>
  initLoading = () =>{
    this.setState({loading:true})
  }
  initLoaded = () =>{
    this.setState({loading:false})
  }
  signOut(e) {
    e.preventDefault();
    this.props.history.push('/login')
  }
  createAlert =  (type,title,detail)  => {
    const getAlert = () => (<SweetAlert type={type} title={title || ""} onConfirm={() => this.hideAlert()}>{detail}</SweetAlert>);
    this.setState({
      alert: getAlert()
    });
  }
  hideAlert() {
    this.setState({
      alert: null
    });
  }
  render() {
    return (
        <>
          <div className="app">
            <AppHeader fixed>
              <Suspense  fallback={this.loading()}>
                <ClientHeader onLogout={e=>this.signOut(e)}/>
              </Suspense>
            </AppHeader>
            <div className="app-body">
              <AppSidebar fixed display="lg">
                <AppSidebarHeader />
                <AppSidebarForm />
                <Suspense>
                  <AppSidebarNav navConfig={navigationClient} {...this.props} router={router}/>


                </Suspense>
                <AppSidebarFooter />
                {/*<AppSidebarMinimizer />*/}
              </AppSidebar>
              <main className="main">
                <AppBreadcrumb appRoutes={routes} router={router}/>
                <Container fluid>
                  <Suspense fallback={this.loading()}>
                    <Switch>
                      {routes.map((route, idx) => {
                        return route.component ? (
                          <Route
                            key={idx}
                            path={route.path}
                            exact={route.exact}
                            name={route.name}
                            render={props => (
                              <route.component {...props}
                                   initLoading={this.initLoading}
                                   initLoaded={this.initLoaded}
                                   baseList={this.state.baseList}
                                   createAlert={this.createAlert}
                              />
                            )} />
                        ) : (null);
                      })}
                      <Redirect from="/" to="/dashboard" />
                    </Switch>
                  </Suspense>
                </Container>
              </main>
              <AppAside fixed>
                <Suspense fallback={this.loading()}>
                  <ClientAside />
                </Suspense>
              </AppAside>
            </div>
            <AppFooter>
              <Suspense fallback={this.loading()}>
                <ClientFooter />
              </Suspense>
            </AppFooter>
          </div>
        {this.state.alert}{(this.state.loading)?(<div className='sweet-loading'><ClipLoader sizeUnit={"px"} size={80} color={'#123abc'} loading={this.state.loading} /> </div>):null }
    </>
    );
  }
}

export default ClientLayout;
